export var GET_QUIZZ_DATA_SUCCESS = 'GET_QUIZZ_DATA_SUCCESS';
export var GET_QUIZZ_DATA_ERROR = 'GET_QUIZZ_DATA_ERROR';
export var GET_QUESTION_SUCCESS = 'GET_QUESTION_SUCCESS';
export var GET_QUESTION_ERROR = 'GET_QUESTION_ERROR';
export var RESULT_SUCCESS = 'RESULT_SUCCESS';
export var RESULT_ERROR = 'RESULT_ERROR';
export var NEXT_STEP = 'NEXT_STEP';
export var COMPLETED_STEP = 'COMPLETED_STEP';
export var END_QUIZZ = 'END_QUIZZ';
export var SET_USER_PREVIOUS_ANSWERS = 'SET_USER_PREVIOUS_ANSWERS';
export var RESET_QUIZZ = 'RESET_QUIZZ';
export var HIDE_MODAL = 'HIDE_MODAL';


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-quiz/es/components/Quizz/quizzActionTypes.js
// module id = 106
// module chunks = 0